// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603300903/js/" + chunkId + "." + {"44":"8b47dca0","225":"06915e86","481":"e6f52d09","486":"e06ebe1f","770":"bd44735d"}[chunkId] + ".0.6157814047016938.chunk.js";
};